import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { SourcesPage } from '../../pages/sources';
import { parseSourceFilters, sourceFiltersToSearch } from '../../entities/source';

export const Route = createFileRoute('/_shell/sources/')({
  validateSearch: (search: Record<string, unknown>) => search,
  component: function SourcesRoute() {
    const navigate = useNavigate();
    const filters = parseSourceFilters(Route.useSearch());

    return (
      <SourcesPage
        filters={filters}
        onFilters={(next) => void navigate({ to: '/sources', search: sourceFiltersToSearch(next) })}
        onOpen={(source) =>
          void navigate({ to: '/sources/$sourceId', params: { sourceId: source.id } })
        }
      />
    );
  },
});
